import axios from 'axios';

const loginInstance = axios.create({
  baseURL: 'https://kanema.staticcomputersinc.com/api',
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
});

export { loginInstance as LoginInstance };